import { TableHead } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { CheckToken } from "../../login/AccessToken";
import axios from "axios";
import {
  DataGrid,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
} from "@mui/x-data-grid";
import "./AdminComponents.scss";
import { toast } from "react-toastify";

function PartnerDetails({ refreshList }) {
  const [partnerData, setPartnerData] = useState([]);
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  const [accessToken, setAccessToken] = useState("");
  const partnerListWithId = partnerData.map((partner, index) => ({
    ...partner,
    id: partner.id !== undefined ? partner.id : index + 1,
  }));

  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const history = useHistory();
  // useEffect(() => {
  //   if (
  //     (sessionStorage.getItem("accessToken") == undefined &&
  //       sessionStorage.getItem("accessToken") == null) ||
  //     sessionStorage.getItem("roleType") !== "admin"
  //   ) {
  //     history.push("/login");
  //   }
  // }, []);

  const Token = () => {
    const check = CheckToken();
    setAuthToken(sessionStorage.getItem("accessToken"));
    return check;
  };
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  useEffect(() => {
    if (sessionStorage.getItem("roleType") === "admin" && Token()) {
      axios
        .get(`${REACT_APP_BACKEND_ROUTE_URL}get_all_partners_list/`, {
          headers: headers,
        })
        .then((res) => {
          console.log(res.data);
          setPartnerData(res.data.partner_list);
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
        });
    }
  }, [authToken, refreshList]);

  const getRowClassName = (params) => {
    return "custom-row";
  };
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        margin: "auto",
        width: "100%",
        maxWidth: "1200px", // Set a max width for large screens
        padding: "1rem",
      }}
    >
      <h1 style={{ textAlign: "center" }}>Partner List</h1>

      {partnerData !== undefined && partnerData.length > 0 ? (
        <div style={{ width: "100%" }}>
          <DataGrid
            rows={partnerListWithId}
            columns={[
              { field: "partner_type", headerName: "Partner Type", width: 120 },
              { field: "company_name", headerName: "Partner Name", width: 120 },
              {
                field: "company_email",
                headerName: "Partner Email",
                width: 250,
              },
              {
                field: "company_phone",
                headerName: "Partner Phone",
                width: 120,
              },
              {
                field: "address_line",
                headerName: "Partner Address",
                width: 120,
              },
              {
                field: "registration_no",
                headerName: "Registration No.",
                width: 100,
              },
              {
                field: "date_of_creation",
                headerName: "Date of Creation",
                width: 200,
                valueFormatter: (params) =>
                  new Date(params.value).toDateString() +
                  " " +
                  new Date(params.value).toLocaleTimeString(),
              },
              {
                field: "active",
                headerName: "Active",
                width: 80,
                renderCell: (params) => (
                  <div
                    style={{
                      color: params.value ? "green" : "red",
                      fontWeight: "bold",
                    }}
                  >
                    {params.value ? "Active" : "Inactive"}
                  </div>
                ),
              },
            ]}
            pageSizeOptions={[5, 10]}
            getRowId={(row) => row.id}
            components={{
              Toolbar: () => (
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div style={{ display: "flex" }}>
                    <GridToolbarColumnsButton />
                    <GridToolbarFilterButton />
                    <GridToolbarDensitySelector />
                  </div>
                </div>
              ),
            }}
            getRowClassName={getRowClassName}
          />
        </div>
      ) : (
        <h3>No Partner is added!!</h3>
      )}
    </div>
  );
}

export default PartnerDetails;
